module.exports = __webpack_public_path__ + "static/media/roboto-300.ef7c6637.woff2";